// extracted by mini-css-extract-plugin
module.exports =  {"content":"W9gS7POe9lCCfyyH8sVw","licenseElement":"PLzoS_JqhSWnCbtRotgi"};